module.exports = __webpack_public_path__ + "static/wojtek-avatar-ced586ef9f4c8b0e1b34cbcf5ac72ab4.webp";